import { format, formatDistanceToNow, isValid, parseISO } from "date-fns";

const toDate = (v) => {
  if (!v) return null;
  const d = typeof v === "string" ? parseISO(v) : v;
  return isValid(d) ? d : null;
};

export const formatDate = (v, fmt = "dd MMM yyyy") => {
  const d = toDate(v);
  return d ? format(d, fmt) : "—";
};

export const formatDateTime = (v) => {
  const d = toDate(v);
  return d ? format(d, "dd MMM yyyy, h:mm a") : "—";
};

export const formatTime = (v) => {
  const d = toDate(v);
  return d ? format(d, "h:mm a") : "—";
};

export const fromNow = (v) => {
  const d = toDate(v);
  return d ? formatDistanceToNow(d, { addSuffix: true }) : "—";
};

export const daysUntil = (v) => {
  const d = toDate(v);
  if (!d) return null;
  return Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
};

export const formatMoney = (amount, currency = "INR") => {
  if (amount == null || isNaN(amount)) return "—";
  const fmt = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  });
  return fmt.format(amount);
};

export const formatLakh = (amount) => {
  if (amount == null) return "—";
  if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(1)}Cr`;
  if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)}L`;
  if (amount >= 1000) return `₹${(amount / 1000).toFixed(0)}K`;
  return `₹${amount}`;
};

export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();
